import { render } from "./administratorAccount.vue?vue&type=template&id=73087fd4&scoped=true"
import script from "./administratorAccount.vue?vue&type=script&lang=js"
export * from "./administratorAccount.vue?vue&type=script&lang=js"

import "./administratorAccount.vue?vue&type=style&index=0&id=73087fd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73087fd4"

export default script